import { useEffect, useRef, useState } from "react";
import { slideDown, slideUp } from '../animation/animation';

const Content = ({ faqs = [], activeCategory = "all", setAttributes, attributes }) => {

    const { faqIcon = {}, theme } = attributes;
    const { open, close } = faqIcon;

    const [openIndex, setOpenIndex] = useState(null);

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
        setAttributes({ activeItem: index });

    };
    const refs = useRef([]);

    useEffect(() => {
        refs.current &&
            Object.keys(refs.current).forEach((key) => {
                const el = refs.current[key];
                if (!el) return;

                if (openIndex === key) {
                    slideDown(el, 900);
                } else {
                    slideUp(el, 900);
                }
            });
    }, [openIndex]);

    const { faqOptions = {} } = attributes || {};
    const { displayFaqTitle } = faqOptions;

    if (!faqs || faqs.length === 0) {
        return <p className="no-result">No FAQ available.</p>;
    }

    if (activeCategory === "all") {
        const grouped = faqs.reduce((acc, f) => {
            if (!f.categories) return acc;
            (acc[f.categories] = acc[f.categories] || []).push(f);
            return acc;
        }, {});

        const keys = Object.keys(grouped);

        return (
            <div className="content-Container">
                {keys.length === 0 && <p className="no-result">No FAQ found.</p>}

                {keys.map((cat) => (
                    <div className="faq-category" data-category={cat} key={cat}>
                        {['themeSeven'].includes(theme) ? null : displayFaqTitle && (
                            <h2 className="faq-title">
                                {cat.charAt(0).toUpperCase() + cat.slice(1)}
                            </h2>
                        )}

                        {grouped[cat].map((faq, idx) => {
                            const globalIndex = `${cat}-${idx}`;
                            const isOpen = openIndex === globalIndex;

                            return (
                                <div className="faq-item"
                                    key={globalIndex}>
                                    <div
                                        className="faq-question"
                                        onClick={() => toggleFaq(globalIndex)}
                                    >
                                        <h3 className="faq-question-title">
                                            {faq.question}
                                        </h3>
                                        <div className="faq-icon">
                                            {isOpen ? <span
                                                className="icon"
                                                dangerouslySetInnerHTML={{ __html: open }}
                                            /> : <span
                                                className="icon"
                                                dangerouslySetInnerHTML={{ __html: close }}
                                            />}
                                        </div>
                                    </div>

                                    <div
                                        className={`faq-answer ${isOpen === true ? 'show' : ''}`}
                                        ref={(el) => (refs.current[globalIndex] = el)}
                                        style={{ overflow: "hidden", display: "none" }}
                                    >
                                        <p className="faq-answer-para">
                                            {faq.answer}
                                        </p>
                                    </div>

                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        );
    }

    //Filter FAQ

    const filteredFaqs = faqs.filter(
        (f) => f.categories && f.categories === activeCategory
    );

    return (
        <div className="content-Container">
            {filteredFaqs.length === 0 ? (
                <p className="no-result">
                    No FAQ found for {activeCategory}.
                </p>
            ) : (
                <div
                    className="faq-category"
                    data-category={activeCategory}
                    key={activeCategory}
                >
                    {['themeSeven'].includes(theme) ? null : displayFaqTitle && (
                        <h2 className="faq-title">
                            {activeCategory.charAt(0).toUpperCase() +
                                activeCategory.slice(1)}
                        </h2>
                    )}

                    {filteredFaqs.map((faq, idx) => {
                        const itemIndex = `${activeCategory}-${idx}`;
                        const isOpen = openIndex === itemIndex;

                        return (
                            <div className="faq-item" key={itemIndex}>
                                <div
                                    className="faq-question"
                                    onClick={() => toggleFaq(itemIndex)}
                                >
                                    <h3 className="faq-question-title">{faq.question}</h3>

                                    <div className="faq-icon">
                                        {isOpen ? (
                                            <span className="icon" dangerouslySetInnerHTML={{ __html: open }} />
                                        ) : (
                                            <span className="icon" dangerouslySetInnerHTML={{ __html: close }} />
                                        )}
                                    </div>
                                </div>

                                <div
                                    className={`faq-answer ${isOpen ? 'show' : ''}`}
                                    ref={(el) => (refs.current[itemIndex] = el)}
                                    style={{ overflow: "hidden", display: "none"  }}
                                >
                                    <p className="faq-answer-para">{faq.answer}</p>
                                </div>
                            </div>
                        );
                    })}

                </div>
            )}
        </div>
    );
};

export default Content;
